<script setup lang="ts">
import { nextTick, onBeforeUnmount, ref, useId, watch } from 'vue';
import DdtCard from './DdtCard.vue';

const props = defineProps<{ open: boolean; title: string }>();
const emit = defineEmits<{ close: [] }>();

const titleId = useId();
const panel = ref<HTMLElement | null>(null);
let previouslyFocused: HTMLElement | null = null;

function onKeydown(event: KeyboardEvent) {
  if (event.key === 'Escape') {
    event.stopPropagation();
    emit('close');
  }
}

watch(
  () => props.open,
  async (open) => {
    if (open) {
      previouslyFocused = document.activeElement as HTMLElement | null;
      await nextTick();
      panel.value?.querySelector<HTMLElement>('input, button, [tabindex]')?.focus();
    } else {
      previouslyFocused?.focus();
    }
  },
);
onBeforeUnmount(() => previouslyFocused?.focus());
</script>

<template>
  <Teleport to="body">
    <div v-if="open" class="ddt-modal__backdrop" @mousedown.self="emit('close')" @keydown="onKeydown">
      <div ref="panel" class="ddt-modal" role="dialog" aria-modal="true" :aria-labelledby="titleId">
        <DdtCard>
          <template #header>
            <span :id="titleId">{{ title }}</span>
          </template>
          <slot />
          <template v-if="$slots.footer" #footer><slot name="footer" /></template>
        </DdtCard>
      </div>
    </div>
  </Teleport>
</template>
